import { parsePhoneNumberFromString } from 'libphonenumber-js'

import { CountryCode, Nil } from '../types'

export function getPhoneNumber(phone?: string | Nil): string {
  if (!phone) {
    return ''
  }

  const phoneNumber = parsePhoneNumberFromString(phone)

  if (!phoneNumber) {
    return phone
  }

  if (phoneNumber.countryCallingCode === '1') {
    return phoneNumber.formatNational()
  }

  // custom mask was required for ES and PT numbers (AAA AAA AAA) in scope of PUI-8183
  if (['34', '351'].includes(phoneNumber.countryCallingCode)) {
    const formattedNationalNumber = phoneNumber.nationalNumber.replace(
      /\D*(\d{3})\D*(\d{3})\D*(\d{3})\D*/,
      '$1 $2 $3',
    )
    return `+${phoneNumber.countryCallingCode} ${formattedNationalNumber}`
  }

  return phoneNumber.formatInternational()
}

export function formatPhoneNumber(
  phoneNumber?: string | Nil,
  country: CountryCode = CountryCode.US,
): string {
  const parsed = phoneNumber && parsePhoneNumberFromString(phoneNumber, country)
  return parsed &&
    (phoneNumber === parsed.nationalNumber || phoneNumber === parsed.number)
    ? getPhoneNumber(phoneNumber)
    : phoneNumber || ''
}

export function parsePhoneNumber(
  phoneNumber?: string | Nil,
  country: CountryCode = CountryCode.US,
) {
  const parsed = phoneNumber && parsePhoneNumberFromString(phoneNumber, country)
  return parsed ? parsed.formatInternational().replace(/\s/g, '') : ''
}
